var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyRainWinds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.777,
    height: 35.43,
    viewBox: "0 0 34.777 35.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e88e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(-965.452 -1522.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "windy",
    transform: "translate(968.3 1522.793)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 5.938,
    cy: 5.938,
    rx: 5.938,
    ry: 5.938,
    transform: "translate(1.697 1.697)",
    fill: "#83cfdf"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 5.938,
    cy: 5.938,
    rx: 5.938,
    ry: 5.938,
    transform: "translate(18.663 6.787)",
    fill: "#e16f47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 5.938,
    cy: 5.938,
    rx: 5.938,
    ry: 5.938,
    transform: "translate(13.573 18.663)",
    fill: "#e6f7fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M1.33,210.661H4.656a1.33,1.33,0,1,0,0-2.661H1.33a1.33,1.33,0,1,0,0,2.661Z",
    transform: "translate(0 -190.705)",
    fill: "#1c3252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M134.634,64a7.326,7.326,0,0,0-7.317,7.317,1.33,1.33,0,0,0,2.661,0,4.656,4.656,0,1,1,4.656,4.656h-13.3a1.33,1.33,0,0,0,0,2.661h8.648a4.656,4.656,0,1,1-4.656,4.656,1.33,1.33,0,1,0-2.661,0,7.317,7.317,0,1,0,12.927-4.69,1.329,1.329,0,0,0,.229-.071A7.313,7.313,0,0,0,134.634,64Z",
    transform: "translate(-110.022 -58.678)",
    fill: "#1c3252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M7.317,11.974H1.33a1.33,1.33,0,0,0,0,2.661H7.317A7.317,7.317,0,1,0,0,7.317a1.33,1.33,0,1,0,2.661,0,4.656,4.656,0,1,1,4.656,4.656Z",
    fill: "#1c3252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "heavy_rain",
    transform: "translate(965.452 1544.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(8.365 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M12.393,28.577a1.393,1.393,0,0,1-1.245-2.017l1.394-2.788a1.394,1.394,0,1,1,2.494,1.248l-1.394,2.788A1.4,1.4,0,0,1,12.393,28.577Z",
    transform: "translate(-11 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(0 1.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M6.393,28.577a1.393,1.393,0,0,1-1.245-2.017l1.394-2.788a1.394,1.394,0,1,1,2.494,1.248L7.642,27.807A1.4,1.4,0,0,1,6.393,28.577Z",
    transform: "translate(-5 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(2.788 5.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M8.393,32.577a1.393,1.393,0,0,1-1.245-2.017l1.394-2.788a1.394,1.394,0,1,1,2.494,1.248L9.642,31.807A1.4,1.4,0,0,1,8.393,32.577Z",
    transform: "translate(-7 -27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(11.154 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M14.393,32.577a1.393,1.393,0,0,1-1.245-2.017l1.394-2.788a1.394,1.394,0,1,1,2.494,1.248l-1.394,2.788A1.4,1.4,0,0,1,14.393,32.577Z",
    transform: "translate(-13 -27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(7.058 8.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625-2",
    "data-name": "Path 625",
    d: "M8.393,32.577a1.393,1.393,0,0,1-1.245-2.017l1.394-2.788a1.394,1.394,0,1,1,2.494,1.248L9.642,31.807A1.4,1.4,0,0,1,8.393,32.577Z",
    transform: "translate(-7 -27)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyRainWinds);
export default __webpack_public_path__ + "static/media/heavyRainWinds.ec28a19b303f66adc025365a6e937586.svg";
export { ForwardRef as ReactComponent };